module.exports = __webpack_public_path__ + "assets/img/066201.2e7d87d9.svg";